export class GetRestoreAccountMetricsConfigResponse {
    'restoreAccountConfig';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountConfig",
            "baseName": "restoreAccountConfig",
            "type": "RestoreAccountMetricsConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetRestoreAccountMetricsConfigResponse.attributeTypeMap;
    }
    constructor() {
    }
}
